module.exports = __webpack_public_path__ + "static/media/alie-ai.bd3bbeb0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/alie-ai.svg
// module id = 2195
// module chunks = 0